import { customerAddressAddMutation } from '@api/graphqlShopify/mutations'
import {
  makeCustomerRequest,
  CustomerAddressError
} from '@api/graphqlShopify/makeCustomerRequest'
import { getErrorMessage } from '@api/graphqlShopify'
import { parse } from '@helpers/shopify'
import trackError from '@helpers/trackError'
import { Address } from '@components/account/types'
import {
  AddAddressData,
  AddAddressSchema
} from '../drawer/shared/AddressFormFields'

export async function addressAdd(payload: AddAddressData, token: string) {
  try {
    const { defaultAddress, ...address } = payload
    const result = AddAddressSchema.safeParse(payload)

    if (!result.success) {
      throw new Error('Invalid address')
    }

    const { data } = await makeCustomerRequest<{
      customerAddressCreate: {
        userErrors: CustomerAddressError[]
        customerAddress: Address
      }
    }>(
      customerAddressAddMutation,
      {
        address,
        defaultAddress
      },
      token
    )

    const { customerAddress, userErrors } = parse(
      data.customerAddressCreate
    ) as {
      customerAddress: Address
      userErrors: CustomerAddressError[]
    }

    if (userErrors?.length) {
      throw userErrors
    }

    return customerAddress
  } catch (e) {
    const error = e as Error
    const errorMessage = getErrorMessage(error)
    trackError(new Error(`addressAdd failed - ${errorMessage}`), {
      address: JSON.stringify(payload),
      error
    })
    throw error
  }
}
